import { connect, ConnectedProps } from "react-redux";
import {
  updateUserPassenger,
  fetchCorpUserPassengers,
  fetchUserPassengers,
  setUserSelectedLapInfantIds,
  setUserSelectedPassengerIds,
  setUserSelectedTravelersList,
  validatePassengers,
} from "../../../actions/actions";
import { getCorporateInfo, getUserPassengerCallState } from "../../../reducer";
import { IStoreState } from "../../../../../reducers/types";
import { FlightTravelerSelectDropdownForm } from "./component";
import {
  selectedTripSelector,
  tripDetailsSelector,
} from "../../../../shop/reducer";

const mapStateToProps = (state: IStoreState) => {
  const selectedTrip = selectedTripSelector(state);
  const tripId = selectedTrip.tripId || "";
  return {
    userPassengerCallState: getUserPassengerCallState(state),
    tripDetails: tripDetailsSelector(state, tripId),
    userRoles: getCorporateInfo(state)?.role,
  };
};

const mapDispatchToProps = {
  updateUserPassenger,
  fetchUserPassengers,
  fetchCorpUserPassengers,
  setUserSelectedPassengerIds,
  setUserSelectedLapInfantIds,
  setUserSelectedTravelersList,
  validatePassengers,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type FlightTravelerSelectDropdownFormConnectorProps = ConnectedProps<
  typeof connector
>;

export const ConnectedFlightTravelerSelectDropdownForm = connector(
  FlightTravelerSelectDropdownForm
);
